export interface ModalsResetActionType {
  type: '@modals/RESET';
  payload: {};
}

export const resetModals = (): ModalsResetActionType => ({
  type: '@modals/RESET',
  payload: {},
});
